import { useAppDispatch, useAppSelector } from "../../app/hooks";
import classes from "./BtcUserDk.module.css";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  addBtcTv,
  addOrUpdateBtcTv,
  editBtcTv,
  removeBtcTv,
  selectBtcConfig,
  selectBtcDsTv,
  setBtcDsTv,
} from "../../features/btc/btcSlice";
import {
  getAllBtcTv,
  createBtcTv,
  updateBtcTv,
  deleteBtcTv,
} from "../../services/btc/btcApi";
import AddIcon from "@mui/icons-material/Add";

import { BtcTitle, MyBtcLayout, theme } from "./BtcAdmin.js";
import { ConfirmButton } from "../dialog/ConfirmButton.js";
import { selectGrp } from "../../features/auth/authSlice";
import { useNotify } from "../hooks/useNotify";
import { NotifySnackbar } from "../dialog/NotifySnackbar";
import { MyDlg } from "./MyDlg";
import {ImportTvStep} from "./ImportTvStep"

const EditForm = ({
  tv,
  onOk,
  onClose = () => {},
  title,
  init = false,
  isEdit = false,
}) => {
  // const [open, setOpen] = useState(init);
  const open = init;
  const handleClose = () => {
    // setOpen(false);
    onClose();
  };

  const [editingObj, seteditedObj] = useState(tv);
  function handleChange(key, value) {
    console.log(key, value);
    seteditedObj({ ...editingObj, [key]: value });
  }

  return (
    <Box>
      <Dialog
        open={open}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"lg"}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent style={{ padding: "0.5rem" }}>
          <Stack direction={"column"} spacing={{ xs: 1, sm: 2 }}>
            <TextField
              disabled={isEdit}
              label="Email"
              value={editingObj.email}
              onChange={(e) => handleChange("email", e.target.value)}
            ></TextField>
            <Stack direction={"row"} spacing={{ xs: 1, sm: 2 }}>
              <FormControl sx={{ width: 0.5 }}>
                <InputLabel id="demo-multiple-checkbox-label">
                  {"Thành phần"}
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  value={editingObj.tp}
                  label="Thành phần"
                  onChange={(e) => handleChange("tp", e.target.value)}
                >
                  {["A", "B", "C"].map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ width: 0.5 }}>
                <InputLabel id="demo-select-small-label">
                  {"Quản lý"}
                </InputLabel>
                <Select
                  style={
                    editingObj.role === "admin"
                      ? { backgroundColor: theme.palette.warning.light }
                      : {}
                  }
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={editingObj.role}
                  label="Quản lý"
                  onChange={(e) => handleChange("role", e.target.value)}
                >
                  <MenuItem value={"admin"}>Có</MenuItem>
                  <MenuItem value={"user"}>Không</MenuItem>
                </Select>
              </FormControl>
            </Stack>
            <TextField
              id="outlined-multiline-static"
              label="Ghi chú"
              multiline
              value={editingObj.note}
              variant="outlined"
              minRows={3}
              fullWidth
              onChange={(e) => handleChange("note", e.target.value)}
            ></TextField>
          </Stack>
        </DialogContent>
        {true && (
          <DialogActions>
            <Button
              onClick={() => {
                handleClose();
                onOk(editingObj);
              }}
              autoFocus
            >
              {isEdit ? "Lưu" : "Thêm mới"}
            </Button>
            <Button onClick={handleClose}>{"Hủy"}</Button>
          </DialogActions>
        )}
      </Dialog>
    </Box>
  );
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const BtcTv = ({ navigate, params = {} }) => {
  console.log("BtcTv");
  const [editingTv, setEditingTv] = useState(null);
  const [creating, setCreateState] = useState(false);
  const [pending, setPending] = useState(true);
  const btcDsTv = useAppSelector(selectBtcDsTv);
  const grp = useAppSelector(selectGrp);

  // snackbar
    const {
      notify,
      success: notifySuccess,
      error: notifyError,
      close,
    } = useNotify();

  const [openImport, setOpenImport] = useState(false);

  // load data
  const dispatch = useAppDispatch();
  useEffect(() => {
    async function loadDsTv() {
      if (!btcDsTv) {
        // case: admin add new
        const { error, result: t_btcDsTv } = await getAllBtcTv(grp);
        console.log("getAllBtcTv: ", t_btcDsTv);
        if (t_btcDsTv) {
          dispatch(setBtcDsTv({ btcDsTv: t_btcDsTv }));
        } else {
          console.error(error);
        }
      }

      setPending(false);
    }
    loadDsTv();
  }, [btcDsTv, dispatch, grp]);

  if (pending) {
    return <>Loading...</>;
  }

  async function onAdd(createdTv) {
    // console.log(createdTv); return;
    var { result, error } = await createBtcTv(createdTv.email, createdTv, grp);
    if (result) {
      dispatch(addBtcTv({ btcTv: result }));
    } else {
      console.error(error);
    }
    setCreateState(false);
  }
  async function handleDelete(id) {
    // console.log(id);return;
    var { result, error } = await deleteBtcTv(id, grp);
    if (result) {
      dispatch(removeBtcTv({ id }));
    } else {
      console.error(error);
    }
  }
  function handleEdit(id) {
    // console.log(id);return;
    setEditingTv(btcDsTv.find((tv) => tv.id === id));
  }
  function handleAdd() {
    setCreateState(true);
  }

  const screenOrientation = 0; // 0:landscape

  async function onSave(editedTv) {
    var changes = {};
    var id = editedTv.id;
    var old = btcDsTv.find((tv) => tv.id === id);
    Object.keys(editedTv).forEach((key) => {
      if (old[key] !== editedTv[key]) {
        changes[key] = editedTv[key];
      }
    });
    var { error, result } = await updateBtcTv(id, changes, grp);
    if (error) {
      console.error(error);
      return;
    }
    dispatch(editBtcTv({ id, changes }));
  }
  function onCancel() {
    setEditingTv(null);
  }

  const title = <BtcTitle navigate={navigate}></BtcTitle>;
  const footer = (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <Button onClick={()=>setOpenImport(true)}>Import</Button>
      <div>
        <Button onClick={() => navigate(-1)}>{"Quay lại"}</Button>
      </div>
    </div>
  );
  async function handleImport(records) {
    const newLst = [];
    const errors = [];
    const createds = [];
    const ids = new Set(btcDsTv.map((m) => m.id));
    records.forEach((r) => {
      if (ids.has(r.id)) {
        // existing
        errors.push(`DK ${r.id} existing`);
      } else {
        newLst.push(r);
      }
    });

    const results = await Promise.all(
      newLst.map(async (r) => {
        if (r.id.startsWith("tmp_")) {
          const { id, ...body } = r;
          const { error, result } = await createBtcTv(body.email, body, grp);
          if (error) {
            console.log(`create TV ${r.email} error: ${error}`);
            errors.push(error);
            return { error };
          } else {
            createds.push(result);
            return { result };
          }
        } else {
          return { result: r };
        }
      }),
    );

    const imported = results.map((r) => r.result).filter(Boolean);
    console.log("handle import: ", { errors, createdTvs: createds, imported });

    dispatch(addOrUpdateBtcTv(imported));

    // notify
    if (imported.length < results.length) {
      notifyError(`Imported ${imported.length}/${results.length}`);
    } else {
      notifySuccess(`Imported ${imported.length}`);
    }

    // close import dialog
    setOpenImport(false);
  }

  return (
    <MyBtcLayout title={title} footer={footer}>
      <div
        style={
          screenOrientation
            ? { display: "flex", flexDirection: "column", height: "100%" }
            : {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "auto",
              }
        }
      >
        <div
          style={
            screenOrientation
              ? { flexGrow: 8, overflow: "auto" }
              : { flexGrow: 8 }
          }
        >
          <Stack direction={"column"} spacing={{ xs: 1, sm: 2 }}>
            {btcDsTv.map((tv, tvIdx) => {
              return (
                <div
                  key={tvIdx}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  className={`${classes.table_row} ${
                    tvIdx % 2 ? classes.table_row2 : classes.table_row1
                  }`}
                >
                  {renderTv(tv, handleEdit, handleDelete)}
                </div>
              );
            })}
          </Stack>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "aliceblue",
            }}
          >
            <IconButton onClick={handleAdd} color="primary" size="large">
              <AddIcon></AddIcon>
            </IconButton>
          </div>
        </div>
        <div style={{ height: "200px" }}>
          <div style={{ margin: "0.5rem" }}>
            <Typography variant="h5">{"Tổng: " + btcDsTv.length}</Typography>
          </div>
        </div>
      </div>
      {editingTv && (
        <EditForm
          tv={editingTv}
          onOk={onSave}
          onClose={onCancel}
          init={true}
          title={"Sửa lại Thành viên"}
          isEdit={true}
        />
      )}
      {creating && (
        <EditForm
          tv={{
            email: "",
            role: "user",
            note: "",
            tp: "A",
          }}
          onOk={onAdd}
          onClose={() => setCreateState(false)}
          init={true}
          title={"Thêm mới Thành viên"}
        />
      )}

      {/* notify */}
      <NotifySnackbar notify={notify} onClose={close} />
      <MyDlg title={"Import TV"} open={openImport} onClose={() => setOpenImport(false)}>
        <ImportTvStep onImport={handleImport} />
      </MyDlg>
    </MyBtcLayout>
  );
};

export default BtcTv;

function renderTv(tv, handleEdit, handleDelete) {
  return (
    <Grid
    container
      spacing={{ xs: 1, sm: 2 }}
      direction="row"
      
      sx={{ flexWrap: "wrap", width: 1 }}
    >
      <Grid item xs={12} md={3}>
        <TextField sx={{ width: 1 }} label="Email" value={tv.email}></TextField>
      </Grid>
      <Grid item xs={12} md={3}>
      <Stack direction={"row"} spacing={2}>
        <TextField
          sx={{ width: 0.5 }}
          label="Thành phần"
          value={tv.tp}
        ></TextField>
        <TextField
          sx={{ width: 0.5 }}
          label="Quản lý"
          value={tv.role}
        ></TextField>
      </Stack></Grid>
      <Grid item xs={12} md={3}>
      <TextField sx={{ width: 1 }} label="Ghi chú" value={tv.note}></TextField></Grid>
      <Grid item xs={12} md={3}>
        <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction="row"
        sx={{
          justifyContent: "flex-end",
          alignItems: "center",
          // width: "100%",
        }}
      >
        <Button size="small" onClick={() => handleEdit(tv.id)}>
          {"Sửa"}
        </Button>
        <ConfirmButton
          onOk={() => handleDelete(tv.id)}
          title={"Xác nhận xóa"}
          message={"Bạn có muốn xóa không? (Ấn [Có] để xóa)"}
        >
          <Button size="small">{"Xóa"}</Button>
        </ConfirmButton>
      </Stack>
      </Grid>
    </Grid>
  );
}

function EditableTv({ tv, handleEdit, handleDelete }) {
  const [editingObj, seteditedObj] = useState(tv);
  function handleChange(key, value) {
    console.log(key, value);
    seteditedObj({ ...editingObj, [key]: value });
  }
  const isEdit = true;
  return (
    <Stack
      spacing={{ xs: 1, sm: 2 }}
      direction="row"
      
      sx={{ flexWrap: "wrap" }}
    >
      <TextField
      // sx={{width:1}}
        disabled={isEdit}
        label="Email"
        value={editingObj.email}
        onChange={(e) => handleChange("email", e.target.value)}
      ></TextField>
      <Stack direction={"row"} spacing={{ xs: 1, sm: 2 }} 
      sx={{width:'auto'}}
      >
        <FormControl sx={{ minWidth: 100 }}>
          <InputLabel id="demo-multiple-checkbox-label">
            {"Thành phần"}
          </InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            value={editingObj.tp}
            onChange={(e) => handleChange("tp", e.target.value)}
            input={<OutlinedInput label={"Thành phần"} />}
          >
            {["A", "B", "C"].map((name) => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 100 }}>
          <InputLabel id="demo-select-small-label">{"Quản lý"}</InputLabel>
          <Select
            style={
              editingObj.role === "admin"
                ? { backgroundColor: theme.palette.warning.light }
                : {}
            }
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={editingObj.role}
            label="Quản lý"
            onChange={(e) => handleChange("role", e.target.value)}
          >
            <MenuItem value={"admin"}>Có</MenuItem>
            <MenuItem value={"user"}>Không</MenuItem>
          </Select>
        </FormControl>
      </Stack>
      <TextField
        id="outlined-multiline-static"
        label="Ghi chú"
        // multiline
        value={editingObj.note}
        variant="outlined"
        // minRows={{xs:3, sm:1}}
        // fullWidth
        onChange={(e) => handleChange("note", e.target.value)}
      ></TextField>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{flexFlow:1}}></div>
        <Stack spacing={{ xs: 1, sm: 2 }} direction="row">
          <Button size="small" onClick={() => handleEdit(editingObj.id)}>
            {"Sửa"}
          </Button>
          <ConfirmButton
            onOk={() => handleDelete(editingObj.id)}
            title={"Xác nhận xóa"}
            message={"Bạn có muốn xóa không? (Ấn [Có] để xóa)"}
          >
            <Button size="small">{"Xóa"}</Button>
          </ConfirmButton>
        </Stack>
      </div>
    </Stack>
  );
}
